
import VimeoExpansionPanel from "@/components/region/help/VimeoExpansionPanel"

import { mdiChat } from "@mdi/js"

export default {
    name: "LivestreamBestPracticesArticle",
    components: { VimeoExpansionPanel },
    data: () => ({
        mdiChat,
    }),
    methods: {
        routeToOabatChat() {
            this.$router.push("/chat?user_id=6")
        },
    },
}
